import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["accessible", "accessibleToPrimaryUser"];
import { AdAccountErrorStates, Networks } from 'automation-ui-action-features/actions/ads-audience-membership/constants';
import { Record } from 'immutable';
const AdAccountStatus = {
  ACTIVE: 'ACTIVE',
  ON_HOLD: 'ON_HOLD',
  CLOSED: 'CLOSED',
  UNKNOWN: 'UNKNOWN'
};

// Format like AdWords as "123-456-7890"
const formatAdWordsAccountId = id => `${id.substring(0, 3)}-${id.substring(3, 6)}-${id.substring(6)}`;
export default class AdAccountRecord extends Record({
  network: null,
  accountId: null,
  accountName: null,
  accessible: null,
  canCreateAudiences: null,
  paymentMethodIsMissing: null,
  status: AdAccountStatus.ACTIVE,
  currentUserHasConnected: false
}, 'AdAccountRecord') {
  constructor(_ref) {
    let {
        accessible,
        accessibleToPrimaryUser
      } = _ref,
      data = _objectWithoutPropertiesLoose(_ref, _excluded);
    super(Object.assign({}, data, {
      accessible: accessible || accessibleToPrimaryUser
    }));
  }
  isActive() {
    return this.status === AdAccountStatus.ACTIVE;
  }
  getDisplayName() {
    return this.network === Networks.ADWORDS ? this.getFormattedName() : this.getShortName();
  }
  getFormattedName() {
    const accountId = this.network === Networks.ADWORDS && this.accountId ? formatAdWordsAccountId(this.accountId) : this.accountId;
    return this.accountName ? `${this.accountName} (${accountId})` : accountId;
  }
  getShortName() {
    return this.network === Networks.ADWORDS && !this.accountName && this.accountId ? formatAdWordsAccountId(this.accountId) : this.accountName || this.accountId;
  }
  getErrorState() {
    if (this.status !== AdAccountStatus.ACTIVE && this.status !== AdAccountStatus.UNKNOWN) {
      return AdAccountErrorStates.INACTIVE;
    }
    if (!this.accessible || !this.canCreateAudiences) {
      return AdAccountErrorStates.PERMISSIONS_NEEDED;
    }
    return AdAccountErrorStates.NONE;
  }
}